export default {
	"autoLineComp": {
		"autoRouting": "自动排线",
		"autoRoutingStrategy": "自动排线策略",
		"availableVehicleTypeInformation": "可用车型信息",
		"departurePrice": "默认出车价",
		"mutilPosPerExtraCost": "默认公里成本",
		"startPlan": "开始计划",
		"vehicleTypeTips": "车型数量必须为大于等于0的整数!",
		"departurePriceTips": "默认出车价必须大于等于0的数字且最多2位小数!",
		"mutilPosPerExtraCostTips": "默认多点配送费必须大于等于0的数字且最多2位小数!",
		"carCount": "车辆数必填!",
		"noLineTips": "未规划出运输线路！",
		"diffSendAddressTips": "请选择相同的发货地址",
		"senderLngLatTips": "运单发货地址没有经纬度信息！",
		"receiverLngLat": "运单收货地址没有经纬度信息！",
		"confirmSendAddressTips": "是否将提送货地相同的运单一起加入派车单？"
	},
	"billingDetailComp": {
		"orderServiceType": "商定费用",
		"billingtableRouteOption": "在派车单上调整",
		"billingtableTransportOption": "在运单上调整",
		"calculationInfoTitle": "复合计费信息",
		"shareMethod": "分摊方式",
		"adjustBillingCost": "手工计费金额(元)",
		"billingDesDialog": "计费说明",
		"contractInfo": "合同信息",
		"projectName": "产品项目",
		"offerInfo": "报价信息",
		"businessData": "业务数据",
		"busDt": "业务时间",
		"billingDt": "计费时间",
		"billingFee": "计费结果",
		"exceptdealChange": "请到异常管理中调整"
	},
	"carChoiceComp": {
		"historyVehiclePre": "已选择车型",
		"addNewVehiclePre": "添加车型"
	},
	"costDialogComp": {
		"event": "事件",
		"detailData": "详细数据"
	},
	"deliveryExecution": {
		"askIndex": "要求顺序",
		"actIndex": "实际顺序",
		"transportArrivedTotal": "完成数",
		"late": "迟到",
		"arrived": "已送达"
	},
	"mainHeader": {
		"deskTop": "我的桌面",
		"quit": "退出",
		"changePwd": "修改密码",
		"nowPwd": "当前密码",
		"newPwd": "新密码",
		"confirmPwd": "确认密码",
		"confirmChange": "确认修改",
		"userInfo": "用户信息"
	},
	"mapTrack": {
		"downloadData": "下载跟踪数据"
	},
	"onwayTracks": {
		"onwaytracksData": "跟踪单据",
		"onwaytracksLx": "流向"
	},
	"operationLogComp": {
		"noChange": "无修改"
	},
	"resourceSelector": {
		"searchCapacityTips": "搜索选择已有运力"
	},
	"switchComp": {
		"switchChange": "点击切换"
	},
	"trackTransitDialog": {
		"tracktransitdialogCreate": "新收货地址信息",
		"askArriveGoodsDt": "要求到货时间"
	},
	"transitDialog": {
		"estimateArriveStationDt": "预计到站时间",
		"estimateLeaveStationDt": "预计出站时间",
		"transitdialogInMark": "中转入站说明",
		"transitdialogOutMark": "中转出站说明"
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/components/components/components.js